export default function testBlock(element, data) {
    // const questions = element.querySelectorAll('.test__block_item[data-number]');
    // const progressItems = element.querySelectorAll('.test__block_progress_item');
    let questionIndex = 1;
    let score = 0;

    function resetTest() {
        questionIndex = 1;
        score = 0;

        element.querySelectorAll('.current').forEach(el => el.classList.remove('current'));
        element.querySelector('.test__block_progress').classList.remove('hidden');
        element.classList.remove('result');

        showQuestion(questionIndex);
    }

    function showQuestion(index) {
        element.querySelectorAll('.test__block_item').forEach(el => el.classList.remove('current'));
        element.querySelectorAll('.test__block_progress_item').forEach(el => el.classList.remove('current'));

        const next = element.querySelector(`.test__block_item[data-number="${index}"]`);
        if (next) next.classList.add('current');

        const progress = element.querySelector(`.test__block_progress_item[data-number="${index}"]`);
        if (progress) progress.classList.add('current');
    }

    element.querySelectorAll('.js-start_test').forEach(btn => {
        btn.addEventListener('click', () => {
            resetTest();
        });
    });

    element.querySelectorAll('.test__block_answer').forEach(answer => {
        answer.addEventListener('click', () => {
            const isFalse = parseInt(answer.dataset.is_false || '0');
            
            if (isFalse === 1) score++;

            questionIndex++;

            const nextQuestion = element.querySelector(`.test__block_item[data-number="${questionIndex}"]`);
            if (nextQuestion) {
                showQuestion(questionIndex);
            } else {
                element.querySelectorAll('.test__block_item').forEach(el => el.classList.remove('current'));
                const resultClass = score >= 1 ? '.result-2' : '.result-1';
                element.querySelector('.test__block_progress').classList.add('hidden');
                const result = element.querySelector(resultClass);
                if (result) {
                    result.classList.add('current');
                    element.classList.add('result');
                }
            }
        });
    });
};